export enum AnalyticsEvent {
  PAGE_VIEW = 'page_view',
  BUTTON_CLICK = 'button_click',
  OPERATION = 'operation',
  TAB_CLICK = 'tab_click',
}
export enum FeatureButtons {
  DASHBOARD = 'dashboard',
  TRANSACTIONS = 'transactions',
  TASKS = 'tasks',
  CUSTOMERS = 'customers',
  MATTERS = 'matters',
  MY_INVOICING = 'my_invoicing',
  WORKTIME = 'worktime',
  TIMER = 'timer',
  CONFLICT_SEARCH = 'conflict_search',
  PROFILE = 'profile',
  MAIL_ACTIONS = 'mail_actions',
  QUICK_ACTIONS = 'quick_actions',
  PROFILE_APPEARANCE = 'profile_appearance',
  PROFILE_CHANGE_ORGANISATION = 'profile_change_organisation',
  PROFILE_LANGUAGE = 'profile_language',
  PROFILE_ABOUT = 'profile_about',
  PROFILE_TRANSACTION_SETTINGS = 'profile_transaction_settings',
  PROFILE_FEATURES = 'profile_features',
  PROFILE_LOGOUT = 'profile_logout',
  PROFILE_ENABLE_DISABLE_FEATURES = 'profile_enable_disable_features',
  PROFILE_PREFERENCES = 'profile_preferences',
}
export enum AnalyticsFeatureOperation {
  TRANSACTION_CREATION = 'transaction_creation',
  TRANSACTION_UPDATE = 'transaction_update',
  TRANSACTION_DELETION = 'transaction_deletion',

  TASK_CREATION = 'task_creation',
  TASK_UPDATE = 'task_update',
  TASK_DELETION = 'task_deletion',
  TASK_COMPLETED = 'task_completed',
  TASK_OPENED = 'task_opened',

  WORKTIME_CREATED = 'worktime_created',
  WORKTIME_UPDATED = 'worktime_updated',
  WORKTIME_DELETED = 'worktime_deleted',

  NOTES_CREATED = 'notes_created',
  NOTES_UPDATED = 'notes_updated',
  NOTES_DELETED = 'notes_deleted',

  TIMER_CREATED = 'timer_created',
  TIMER_UPDATED = 'timer_updated',
  TIMER_DELETED = 'timer_deleted',

  CONFLICT_CHECK_CREATION = 'conflict_check_creation',
  MATTER_REQUEST_CREATION = 'matter_request_creation',

  PRELIMINARY_INVOICE_REVIEW_SKIPPED = 'preliminary_invoice_review_skipped',
  PRELIMINARY_INVOICE_REVIEWED = 'preliminary_invoice_reviewed',
  PRELIMINARY_INVOICE_CREATED = 'preliminary_invoice_created',
}
export enum AnalyticsPage {
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  TRANSACTION_LISTING = 'transaction_listing',
  TRANSACTION_DETAIL = 'transaction_detail',
  TRANSACTION_ADD_EDIT = 'transaction_add_edit',
  TASK_DETAIL = 'task_detail',
  TASK_ADD_EDIT = 'task_add_edit',
  CRITICAL_TASK_ADD_EDIT = 'critical_task_add_edit',

  WORK_TIME_LISTING = 'work_time_listing',
  WORK_TIME_DETAIL = 'work_time_detail',
  WORK_TIME_ADD_EDIT = 'work_time_add_edit',

  HOME = 'home',
  NOTES_DETAIL = 'notes_detail',
  ENTRIES_MANAGEMENT = 'entries_management',
  MATTER_SELECTION = 'matter_selection',
  TIMER_LISTING = 'timer_listing',
  TIMER_DETAIL = 'timer_detail',
  TIMER_ADD_EDIT = 'timer_add_edit',

  CONFLICT_SEARCH_LISTING = 'conflict_search_listing',
  CONFLICT_SEARCH_DETAIL = 'conflict_search_detail',
  CREATE_CONFLICT_CHECK = 'create_conflict_check',
  CONFLICT_CHECK_DETAIL = 'conflict_check_detail',
  CREATE_MATTER_REQUEST = 'create_matter_request',

  CUSTOMER_LISTING = 'customer_listing',
  CUSTOMER_DETAIL = 'customer_detail',

  MATTER_DETAIL = 'matter_detail',
  MATTER_LISTING = 'matter_listing',

  MATTER_REQUEST_DETAIL = 'matter_request_detail',
  MY_INVOICING_LISTING = 'my_invoicing_listing',
}
